<template>
  <div class="base-info-component">
    <div class="left-box">
      <div class="avatar-box">
        <img v-if="peer.logo" class="avatar-img" :src="peer.logo" alt="">
        <img v-else class="avatar-img" src="../../../assets/imgs/new-user/avatar-default.png" alt="">
        <div v-if="userInfo.is_admin" class="edit-logo" @click="handleEditPeerInfo">修改</div>
      </div>
      <div class="peer-info">
        <div class="peer-name-box">
          <div class="peer-name">{{peer.peer_name}}</div>
          <div v-if="peer.enable_api" class="api-tag"></div>
        </div>

        <div class="peer-address">
          <div class="address-text">{{getAddress(pcds, peer)}}</div>
          <div class="edit-box" v-if="userInfo.is_admin" @click="handleEditPeerInfo">
            <img class="icon-edit" src="../../../assets/imgs/new-user/icon-edit.png" alt="">
            <div class="text">修改</div>
          </div>
        </div>
        <div class="order-info">
          <div class="order-info-item" @click="gotoOrderList($event, {order_status: '3'})">
            <div class="item-num">
              <div class="num">{{peerCount.unpaid_order_count}}</div>
              <div class="unit">单</div>
            </div>
            <div class="item-name">待支付</div>
          </div>
          <div class="order-info-item" @click="gotoOrderList($event, {applicant_status: '1'})">
            <div class="item-num">
              <div class="num">{{peerCount.pre_approved_count}}</div>
              <div class="unit">人</div>
            </div>
            <div class="item-name">待预审</div>
          </div>
          <div class="order-info-item" @click="gotoOrderList($event, {applicant_status: '4'})">
            <div class="item-num">
              <div class="num">{{peerCount.embassy_count}}</div>
              <div class="unit">人</div>
            </div>
            <div class="item-name">使馆审核</div>
          </div>
          <div class="order-info-item" @click="gotoOrderList($event, {applicant_status: '5'})">
            <div class="item-num">
              <div class="num">{{peerCount.sign_success_count}}</div>
              <div class="unit">本</div>
            </div>
            <div class="item-name">已出签</div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-box">
      <div class="balance-box">
        <div class="balance-label">可用余额 (元)</div>
        <div class="balance-value">
          <div v-if="peer.withdraw_fee" class="withdraw-balance-value">
            提现中：<span class="price"><span class="unit">¥</span>{{peer.withdraw_fee / 100}}</span>
            </div>
          <div class="usable-balance-value">
            <div class="unit">¥</div>
            <div class="value">{{peer.balance_amount / 100}}</div>
          </div>
        </div>
        
      </div>
      <div class="recharge-btn" @click="handleShowRechargeDialog"></div>
    </div>

    <!-- 充值弹窗 -->
    <recharge-dialog ref="rechargeDlg" v-model="showRechargeDialog" @recharge-success="rechargeSuccess" @audit-success="auditSuccess">
    </recharge-dialog>
    <!-- 重复提交弹框 -->
    <common-dialog
      :show.sync="showErrorDialog"
      title="重复提交提醒"
    >
       <div class="repeat-dlg-content">您最近已提交过一笔金额相同的汇款记录，请勿重复提交，具体可查看对公汇款记录。</div>
       <div class="repeat-dlg-footer" slot="footer">
         <button @click="goAuditList" class="s-btn btn-blue btn-lg">前往查看</button>
        </div>
    </common-dialog>

    <!-- 编辑商户信息 -->
    <edit-peer-info-dialog
      :show.sync="editPeerInfoDialog.visible"
      :peer="peer"
      :pcds="pcds"
      @success="getPeer"
    ></edit-peer-info-dialog>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import { mapState } from 'vuex';
import Http from '../../../libs/http';
import addressUtils from '../../../libs/address-utils';
import pcdService from '../../../services/pcd-service';
import rechargeDialog from '../../../components/common/recharge-dialog';
import EditPeerInfoDialog from './edit-peer-info-dialog';
import vueBus from '../../../libs/bus';
import User from '../../../libs/user.js';
import CommonDialog from '../../../components/common/modals/common-dialog/common-dialog.vue';

export default {
  components: {
    rechargeDialog,
    EditPeerInfoDialog,
    CommonDialog,
  },
  data() {
    return {
      peer: {},
      peerCount: {},
      pcds: {},
      showRechargeDialog: false,
      editPeerInfoDialog: {
        visible: false,
      },
      logoUploading: false,
      showErrorDialog: false,
    };
  },
  computed: {
    ...mapState('user', ['userInfo']),
  },
  created() {
    pcdService.getPcd().then((pcds) => {
      this.pcds = pcds;
      this.getPeerCount();
      this.getPeer();
    }).catch((e) => {
      if (e) console.log(e);
    });

    this.startEventBus();
  },
  methods: {
    // 启动bus,用于监听优惠卷页面打开充值弹窗
    startEventBus() {
      vueBus.$on('open-recharge-dialog', () => {
        this.handleShowRechargeDialog();
      });
      this.$once('hook:beforeDestroy', () => {
        vueBus.$off('open-recharge-dialog');
      });
    },

    getAddress: addressUtils.getAddress,
    // 获取同业信息
    getPeer() {
      Http.post('/visa_peer_query').then((data) => {
        this.peer = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    getPeerCount() {
      Http.post('/peer_order_count').then((data) => {
        this.peerCount = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 显示充值弹窗
    handleShowRechargeDialog(e) {
      if (e) {
        sensorsdata.quick('trackHeatMap', e.target);
        // 还有首页充值送券时候会跳转到该页面
        sensorsdata.track('Recharge_voucher', {
          peer_name: User.peer.peer_name,
          visa_peer_id: User.peer.visa_peer_id || '',
          platform_type: 'PC',
          page_from: this.$route.query.page_from || '我的页-余额充值',
        });
      }

      this.showRechargeDialog = true;
    },
    // 充值成功
    rechargeSuccess() {
      vueBus.$emit('recharge-success');
      this.getPeer();
    },

    auditSuccess(type) {
      if (type === 'success') {
        location.reload();
      } else {
        this.showErrorDialog = true;
      }
    },
    // 跳转订单列表
    gotoOrderList(e, query) {
      sensorsdata.quick('trackHeatMap', e.target);
      // 管理员、财务
      if (User.isAdminRole() || User.isFinanceRole()) {
        this.$router.push({ name: 'adminOrder', query });
      } else { // 操作员
        this.$router.push({ name: 'orders', query });
      }
    },
    // 显示编辑商户信息弹窗
    handleEditPeerInfo(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.editPeerInfoDialog.visible = true;
    },
    goAuditList() {
      this.showErrorDialog = false;
      this.$router.push('/user/audit');
    },
  },
};
</script>
<style lang="less" scoped>
.base-info-component{
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
  border-radius: 2px;
  display: flex;
  justify-content: space-between;
  padding: 24px 32px 24px 32px;
  .left-box{
    flex-grow: 1;
    display: flex;
    align-items: flex-start;
    overflow: hidden;
    .avatar-box{
      flex-shrink: 0;
      font-size: 0;
      margin-right: 24px;
      position: relative;
      border-radius: 50%;
      overflow: hidden;
      .avatar-img{
        width: 72px;
        height: 72px;
        border-radius: 50%;
        object-fit: cover;
      }
      .edit-logo{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 32px;
        background: rgba(0, 0, 0, 0.6);
        display: none;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
      }
      &:hover{
        .edit-logo{
          display: flex;
        }
      }
    }
    .peer-info{
      padding-top: 6px;
      overflow: hidden;

      .peer-name-box{
        display: flex;
        align-items: center;
        .peer-name{
          font-size: 22px;
          color: #2F333D;
          line-height: 33px;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .api-tag{
          flex-shrink: 0;
          height: 20px;
          width: 40px;
          background: url(../../../assets/imgs/new-user/icon-api.png) no-repeat center / 100% 100%;
          margin-left: 10px;
        }
      }
      .peer-address{
        margin-top: 4px;
        color: #2F333D;
        font-size: 16px;
        line-height: 25px;
        display: flex;
        align-items: center;
        .address-text{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .edit-box{
          flex-shrink: 0;
          margin-left: 8px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .icon-edit{
            width: 12px;
            height: 12px;
          }
          .text{
            color: #599FFF;
            font-size: 14px;
            margin-left: 2px;
          }
        }
      }
      .order-info{
        margin-top: 24px;
        display: flex;
        .order-info-item{
          height: 100%;
          display: flex;
          flex-direction: column;
          padding: 0 40px;
          border-right: 1px solid #E9EEF2;
          cursor: pointer;
          &:first-child{
            padding-left: 0;
          }
          &:last-child{
            border-right: none;
          }
          &:hover{
            .item-num{
              color: #599FFF;
            }
            .item-name{
              color: #599FFF;
              &::after{
                background: url(../../../assets/imgs/new-user/icon-right-blue.png) no-repeat center / 100% 100%;
              }
            }
          }
          .item-num{
            display: flex;
            align-items: baseline;
            color: #2F333D;
            .num{
              font-size: 20px;
              line-height: 26px;
              font-weight: 600;
            }
            .unit{
              margin-left: 4px;
              font-size: 14px;
              line-height: 20px;
            }
          }
          .item-name{
            display: flex;
            align-items: center;
            color: #5F666E;
            font-size: 16px;
            line-height: 22px;
            margin-top: 4px;
            &::after{
              content: "";
              width: 12px;
              height: 12px;
              margin-left: 2px;
              background: url(../../../assets/imgs/new-user/icon-right.png) no-repeat center / 100% 100%;
            }
          }
        }
      }
    }
  }
  .right-box{
    margin-left: 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .balance-box{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding-top: 4px;
      .balance-label{
        color: #2F333D;
        font-size: 16px;
        line-height: 22px;
      }
      .balance-value{
        margin-top: 12px;
        display: flex;
        align-items: center;
        .withdraw-balance-value{
          margin-right: 8px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #EAF3FF;
          padding: 0 8px;
          border-radius: 2px;
          color: #2F333D;
          font-size: 16px;
          line-height: 1;
          .price{
            font-weight: 600;
            .unit{
              font-size: 12px;
            }
          }
        }
        .usable-balance-value{
          display: flex;
          align-items: baseline;
          .unit{
            color: #2F333D;
            font-size: 20px;
            line-height: 28px;
            font-weight: 600;
            margin-right: 4px;
          }
          .value{
            color: #2F333D;
            font-size: 32px;
            line-height: 46px;
            font-weight: 600;
          }
        }
        
      }
    }
    .recharge-btn{
      margin-top: 12px;
      width: 188px;
      height: 44px;
      cursor: pointer;
      background: url(../../../assets/imgs/new-user/recharge.gif) no-repeat center / 100% 100%;
    }
  }
  .repeat-dlg-content{
    padding: 24px;
    font-size: 16px;
    line-height: 24px;
  }
  .repeat-dlg-footer{
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/components/base-info.vue